module.exports = "/_next/static/chromiums/og-1200x630-purpose-0fa66724a5bc9650c559a0edb3975c45.jpg";